
import { Dialog, DialogContent, IconButton, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { tyreApiNm } from "./constant"
import { alertConfirmDelete } from "components/Alert"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import AddButton from "components/buttons/AddButton"
import { addIdForDataGrid } from "utils"
import { DeleteRounded } from "resource/muiImport"

const columns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "TyrSzNm",
    headerName: "ขนาดยาง",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "actions",
    headerName: "",
    width: 50,
    align: 'center',
    renderCell: () => (
      <IconButton size="small">
        <DeleteRounded color="error" fontSize="small" />
      </IconButton>
    )
  },
]

const TyreSizeDialog = ({ dialogOpen, setDialogOpen, onFinish }) => {

  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [newSize, setNewSize] = useState("")

  const loadData = useCallback(() => {
    ax.post(tyreApiNm.getTyreSize, {}).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'TyrSzId'))
      }
    })
  }, [ax])

  const handleAdd = useCallback(() => {
    if (!newSize.trim()) return
    const postData = {
      TyrSzNm: newSize.trim(),
      IsActv: 1
    }
    ax.post(tyreApiNm.insertTyreSize, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'TyrSzId'))
        setNewSize("")
        onFinish()
      }
    })
  }, [ax, newSize, onFinish])

  const handleCellClick = useCallback((params) => {
    if (params.field === 'actions') {
      alertConfirmDelete(() => {
        ax.post(tyreApiNm.deleteTyreSize, { TyrSzId: params.id }).then(value => {
          if (value.data) {
            setDataTable(addIdForDataGrid(value.data, 'TyrSzId'))
            onFinish()
          }
        })
      })
    }
  }, [ax, onFinish])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      handleAdd()
    }
  }, [handleAdd])

  useEffect(() => {
    if (dialogOpen) {
      loadData()
      setNewSize("")
    }
  }, [dialogOpen, loadData])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="จัดการขนาดยาง"
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1, height: 400 }}>
          <BoxFR sx={{ gap: 1 }}>
            <TextField
              size="small"
              fullWidth
              label="ขนาดยาง"
              value={newSize}
              onChange={(e) => setNewSize(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <AddButton onClick={handleAdd}>เพิ่ม</AddButton>
          </BoxFR>
          <DataGridCellExpand
            hideFooter
            rows={dataTable}
            columns={columns}
            onCellClick={handleCellClick}
          />
        </BoxFC>
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(TyreSizeDialog)
